import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appDirectiveWidget]',
})
export class WidgetDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
